import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ContentLoader from "react-content-loader";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import Resizer from "react-image-file-resizer";
import { Edit } from "lucide-react"; // Kept for the Edit button

import GetCompanyInfoService from "../../services/company/getCompanyInfoService";
import { getTrans as t } from "../../Localization/translations";
import EditCompanyService from "../../services/company/editCompanyService";
import Helper from "../../Helper";

function CompanyProfile({ setProfileImage, customerPermission }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [company_name, setCompnayName] = useState("");
  const [address, setAddress] = useState("");
  const [country_name, setCountry] = useState([]);
  const [state_name, setState] = useState([]);
  const [city, setCity] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [currency, setcCurrency] = useState("");
  const [lender_id, setLenderId] = useState("");
  const [date_registered, setDate_of_registeration] = useState("");
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingimage, setLoadingImage] = useState(false);
  const [user_filed, setUserFiled] = useState("");
  
  const { handleSubmit } = useForm();
  const form = useRef();
  const checkBtn = useRef();

  const handelDefault = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setEmail(response.data.user_email);
      setName(response.data.name);
      setCompnayName(response.data.company_name);
      setAddress(response.data.address);
      setCountry(response.data.country_name);
      setState(response.data.state_name);
      setCity(response.data.city);
      setZipCode(response.data.zip_code);
      setPhoneNumber(response.data.phone_number);
      setcCurrency(response.data.currency);
      setLenderId(response.data.lender_id);
      setDate_of_registeration(response.data.date_registered);
      setImage(response.data.image);
      setLoading(false);
      setUserFiled(response.data.user_filed);
    });
  };

  useEffect(() => {
    handelDefault();
    if (image1 != null) {
      handleRegister();
    }
  }, [image1]);

  const handleRegister = () => {
    setLoadingImage(true);
    const form_data = new FormData();
    form_data.append("image", image1);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditCompanyService.editImage(form_data.get("image"))
        .then((response) => {
          if (response.data.success) {
            setLoadingImage(false);
            setProfileImage(true);
            handelDefault();
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            });
            setLoadingImage(false);
          }
        })
        .catch(() => {
          toast.error("Something went wrong");
          setLoadingImage(false);
        });
    }
  };

  const handleChange = (e) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(e.target.files[0]);
    img.onload = () => {
      if (img.width >= 335) {
        try {
          Resizer.imageFileResizer(
            e.target.files[0], 335, 180, "JPEG", 100, 0,
            (uri) => { setImage1(uri); }, "file"
          );
        } catch (err) {}
        return true;
      }
      setImage1(e.target.files[0]);
      return true;
    };
  };

  return (
    <div className="container-fluid">
      <ToastContainer />
      {loading === false ? (
        <>
          <div className="header pb-0">
            <div className="d-lg-flex"></div>
          </div>
          <div className="row my-3">
            {/* Using col-12 to fill width since it's a standalone page now */}
            <div className="col-12">
              <div className="card mb-4 p-4 shadow-sm">
                <div className="row">
                  <div className="col-12 col-md-8">
                    <h5 className="mb-1 d-flex align-items-center">
                      <i className="fas fa-building me-2 text-lg flex items-center gap-2"></i>{" "}
                      {t("Company Profile")}
                    </h5>
                    <p className="text-sm text-gray-600">
                      Manage your company information and settings
                    </p>
                  </div>
                  <div className="col-12 col-md-4">
                    {customerPermission !== "Customer" && user_filed === "Company" && (
                      <div className="d-flex justify-content-end">
                        <Link to="/profile/editprofile" className="btn btn-primary">
                          <Edit className="me-2" /> Edit Profile
                        </Link>
                      </div>
                    )}
                  </div>
                </div>

                {/* Logo and Company Name */}
                <div className="d-flex align-items-center mt-3">
                  <div className="position-relative me-3">
                    {loadingimage ? (
                      <ContentLoader
                        viewBox="0 0 500 500"
                        height={200}
                        width={500}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
                        <ellipse cx="120" cy="140" rx="28" ry="28" />
                      </ContentLoader>
                    ) : (
                      <>
                        <img
                          src={image || process.env.PUBLIC_URL + "/static/images/logo.png"}
                          alt="Logo"
                          className="img-fluid rounded shadow-sm"
                          style={{ width: 130, height: 100 }}
                        />
                      </>
                    )}
                  </div>
                </div>

                <Form onSubmit={handleSubmit(handleRegister)} ref={form}>
                  <input type="file" name="image" id="file" multiple onChange={handleChange} style={{ display: "none" }} />
                  <div className="container-camera">
                    <input type="file" name="image" id="file" multiple onChange={handleChange} style={{ display: "none" }} />
                    <div>
                      <div className="lable-camera">
                        <label className="text-right" htmlFor="file">
                          <span className="fa fa-solid fa-camera fa-xl"> </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>

                <hr className="my-3" />
                
                <div className="container px-0">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong> {t("Company Name")}</strong></span></div>
                      <div><i className="fa fa-building me-1" /> {company_name}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("User Name")}</strong></span></div>
                      <div>{name}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Registration Date")} </strong></span></div>
                      <div><i className="fa fa-calendar me-1" /> {Helper.DateNormal(date_registered)}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Phone")}</strong></span></div>
                      <div><i className="fa fa-phone me-1" /> {phone_number || "None"}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Email")}</strong></span></div>
                      <div><i className="fa fa-envelope me-1" /> {email}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Currency")}</strong></span></div>
                      <div>{currency}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Address")}</strong></span></div>
                      <div><i className="fa fa-map-marker-alt me-1" /> {address}, {city}, {state_name}, {zip_code}, {country_name}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div><span className="tc"><strong>{t("Lender ID")}</strong></span></div>
                      <div><i className="fa fa-id-card me-1" /> {lender_id || "None"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <ContentLoader viewBox="0 0 400 160" backgroundColor="rgba(0,0,0,0.06)" foregroundColor="rgba(0,0,0,0.12)">
          <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
          <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
          <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
          <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
          <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
          <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
        </ContentLoader>
      )}
    </div>
  );
}

export default CompanyProfile;